import { render } from "./HeaderHome.vue?vue&type=template&id=71736d1a"
import script from "./HeaderHome.vue?vue&type=script&lang=js"
export * from "./HeaderHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\thangpn\\code\\free\\frontend-amber-hills\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__